// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recommend-like[data-v-cbb3f2c8]{font-weight:600}.recommend-box[data-v-cbb3f2c8]{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between}.recommend-box .recommend-title[data-v-cbb3f2c8]{text-decoration:none;color:inherit}.recommend-box .recommend-time[data-v-cbb3f2c8]{font-size:14px}.recommend-description[data-v-cbb3f2c8]{font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#99b0c7}", ""]);
// Exports
module.exports = exports;
